import {
  GET_LIST_NGUONVON,
  GET_LIST_NGUONVON_SUCCESS,
  GET_LIST_NGUONVON_FAILURE,
} from "../../actions/NguonVon/actionTypes";

const initialState = {
  List: [],
  TongTien: 0,
  TongBanGhi: 0,
};
const getListNguonVon = (state, action) => ({
  ...state,
  getListNguonVonLoading: true,
});

const getListNguonVonSuccess = (state, action) => {
  return {
    ...state,
    List: action.payload.List,
    TongTien: action.payload.TongTien,
    TongBanGhi: action.payload.TongBanGhi,
    getListNguonVonLoading: false,
  };
};

const getListNguonVonFailed = (state, action) => ({
  ...state,
  getListNguonVonLoading: false,
  List: [],
});
export const listNguonVonReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_NGUONVON:
      return getListNguonVon(state, action);
    case GET_LIST_NGUONVON_SUCCESS:
      // alert("tuty");
      return getListNguonVonSuccess(state, action);
    case GET_LIST_NGUONVON_FAILURE:
      //alert('false')
      return getListNguonVonFailed(state, action);
    default:
      return state;
  }
};

export default listNguonVonReducer;
